import { useCallback, useEffect, useState } from "react";
import { OnboardingTutorialStyled } from "./styled/OnboardingTutorialStyled";
import appHistory from "../../../app/appHistory";
import { RouterPaths } from "../../../app/appConstants";
import { OnboardingTutorialContext } from "./onboardingTutorialContext";
import { Loader } from "../../../components/Loader/Loader";
import { ONBOARDING_TUTORIAL_REDIRECT_ROUTES } from "./onboardingTutorialConstants";
import { cacheImages } from "./onboardingTutorialUtils";
import { generatePath, Switch, useParams } from "react-router";
import {
    OnboardingTutorialCloseButton
} from "./components/OnboardingTutorialCloseButton/OnboardingTutorialCloseButton";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import useEffectOnce from "../../../hooks/useEffectOnce";
import { Redirect, Route } from "react-router-dom";
import { getOnboardingTutorialConfigInfo } from "./onboardingTutorialConfig";
import { OnboardingTutorialNavigation } from "./components/OnboardingTutorialNavigation/OnboardingTutorialNavigation";
import { useSetBodyBackgroundColor } from "../../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingTutorial = () => {
    const [isLoading, setIsLoading] = useState(true);
    const {attempt, step} = useParams();
    const {locale} = useLangContext();
    const {pushGtmEvent} = useGTMEvent();
    const {steps: currentSteps, images: currentImages} = getOnboardingTutorialConfigInfo(attempt);
    useSetBodyBackgroundColor('var(--color-surface)', true);

    const currentStep = +step;

    useEffect(() => {
        cacheImages(currentImages, '/assets/onboarding/', locale)
                .catch(() => {
                })
                .then(() => setIsLoading(false))
    }, [currentImages, locale]);

    useEffectOnce(() => {
        pushGtmEvent({event: 'onboarding_open', module: 'OnboardingTutorial', attempt});
    });

    const handleSwitchTutorialStep = useCallback((step) => {
        appHistory.push(generatePath(RouterPaths.onboardingTutorial, {attempt, step}));
    }, [attempt]);

    const handleStepBack = useCallback(() => {
        handleSwitchTutorialStep(currentStep - 1);
    }, [currentStep, handleSwitchTutorialStep]);

    const handleStepForward = useCallback(() => {
        handleSwitchTutorialStep(currentStep + 1);
    }, [currentStep, handleSwitchTutorialStep]);

    const {name: currentStepName} = currentSteps[currentStep] || {};
    const previousStepName = step ? currentSteps[currentStep - 1]?.name : null;

    if (isLoading) {
        return <Loader show/>
    }

    return (
            <OnboardingTutorialContext.Provider value={{
                handleStepBack,
                handleStepForward,
                currentStep,
                currentStepName,
                previousStepName,
                stepsCount: currentSteps.length,
            }}>
                <OnboardingTutorialStyled>
                    <div className="d-flex justify-content-end align-items-center pt-2 px-2">
                        <OnboardingTutorialCloseButton/>
                    </div>
                    <div className="flex-grow-1">
                        <Switch>
                            {
                                currentSteps.map(({component: StepComponent, name}, index) => (
                                        <Route
                                                key={name}
                                                exact
                                                path={generatePath(RouterPaths.onboardingTutorial, {
                                                    attempt,
                                                    step: index
                                                })}
                                                component={StepComponent}
                                        />
                                ))
                            }
                            <Route
                                    exact
                                    path={generatePath(RouterPaths.onboardingTutorial, {attempt, step: -1})}
                                    render={() => (
                                            <Redirect
                                                    to={generatePath(ONBOARDING_TUTORIAL_REDIRECT_ROUTES.PREVIOUS_ROUTE, {attempt})}/>
                                    )}/>
                            <Route exact
                                   path={generatePath(RouterPaths.onboardingTutorial, {
                                       attempt,
                                       step: currentSteps.length
                                   })}
                                   render={() => (
                                           <Redirect
                                                   to={generatePath(ONBOARDING_TUTORIAL_REDIRECT_ROUTES.NEXT_ROUTE, {attempt})}/>
                                   )}/>
                            <Redirect to={generatePath(RouterPaths.onboardingTutorial, {attempt, step: 0})}/>
                        </Switch>
                    </div>
                    <OnboardingTutorialNavigation/>
                </OnboardingTutorialStyled>
            </OnboardingTutorialContext.Provider>
    )
}